import React, { useEffect, useState } from "react";
import ManageUserActivity from "./ManageUserActivity";
import RequestFormActivity from "./RequestFormActivity";
import { useSelector, useDispatch } from "react-redux";
import { reportingAction } from "../../_store";
import { masterActions, authActions } from "../../_store";


const Reporting = () => {
  const dispatch = useDispatch();
  const reduxTabActiveClass = useSelector(
    (state) => state.reporting?.tabActiveHistory.currentTabName
  );
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const [tabKey, setTabKey] = useState(0); // Key to force refresh
  // Dynamically set class for tabs
  const handleTabClick = (tabName) => {
    dispatch(reportingAction.setTabActive({ currentTabName: tabName }));
    dispatch(reportingAction.resetreqActivityDataSearch());
    dispatch(reportingAction.resetuserActivityDataSearch());
    setTabKey((prevKey) => prevKey + 1)
  };
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );

    // dispatch(reportingAction.resetTabActive());
  }, [isPageReloading]);

  return (
    <div>
      {commonFacilityCode > 0 ? (
        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
          <div className="overflow-auto">
            <ul
              className="nav nav-tabs tab-bg d-flex flex-nowrap overflow-auto"
              style={{ whiteSpace: "nowrap" }}
            >
              <li className="nav-item flex-shrink-0">
                <a
                  href="#ManagementUser"
                  data-bs-toggle="tab"
                  className={`nav-link ${reduxTabActiveClass === "ManagementUser" ? "active" : "text-black"
                    }`}
                  onClick={() => handleTabClick("ManagementUser")}
                >
                  <span className="d-sm-none"> Management User Activity</span>
                  <span className="d-sm-block d-none  font-size-15 ">
                    Management User Activity
                  </span>
                </a>
              </li>
              <li className="nav-item flex-shrink-0">
                <a
                  href="#RequestForm"
                  data-bs-toggle="tab"
                  className={`nav-link ${reduxTabActiveClass === "RequestForm" ? "active" : "text-black"
                    }`}
                  onClick={() => handleTabClick("RequestForm")}
                >
                  <span className="d-sm-none">Requests Form Activity</span>
                  <span className="d-sm-block d-none  font-size-15 ">
                    Requests Form Activity
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content panel rounded-0 p-3 m-0">
            <div
              className={`tab-pane fade ${reduxTabActiveClass === "ManagementUser" ? "active show" : ""
                }`}
              id="ManagementUser"
            >
              <ManageUserActivity key={tabKey} />
            </div>
            <div
              className={`tab-pane fade ${reduxTabActiveClass === "RequestForm" ? "active show" : ""
                }`}
              id="RequestForm"
            >
              <RequestFormActivity key={tabKey} />
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </div>
  );
};

export default React.memo(Reporting);
